import swal from "sweetalert";

const Confirm = (title, text, icon, dangerMode, cancelButton, okButton) => {
    return swal({
        title,
        text,
        icon,
        dangerMode,
        buttons: [cancelButton || "لغو", okButton || "تایید"]
    });
}

export default Confirm;